var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcnFacade(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 13,
    width: 10.154,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.746 13.002H.404a.4.4 0 01-.4-.4V4.885a.39.39 0 01.123-.294L4.801.12a.4.4 0 01.561 0l4.674 4.471a.4.4 0 01.123.294v7.717a.407.407 0 01-.413.4zM3.088 9.213a.6.6 0 00-.426 1.025 3.3 3.3 0 004.67 0 .6.6 0 000-.849.6.6 0 00-.85 0 2.1 2.1 0 01-2.971 0 .6.6 0 00-.423-.178zm4.01-2.707a.9.9 0 10.9.9.9.9 0 00-.9-.904zm-4.2 0a.9.9 0 10.9.9.9.9 0 00-.9-.904z",
    fill: "#fff"
  })));
}

export default SvgIcnFacade;